import classnames from 'classnames/bind'
import { GlobalThemeColors } from '~/@types/colors'

import {
  Accordion,
  AccordionPanel,
} from '@unlikelystudio/react-abstract-components'

import RightColumnRow from '~/components/UI/TwoColumnsLayout/RightColumnRow'

import { useStyle } from '~/providers/StyleProvider'

import useTextColorFromTheme from '~/hooks/useTextColorFromTheme'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type TwoColumnsAccordionProps = {
  className?: string
  headlineClassName?: string
  bordersTheme?: string
  items?: {
    header: string
    body: any[]
  }[]
}

function TwoColumnsAccordion({
  className,
  items,
  headlineClassName,
  bordersTheme = GlobalThemeColors.SilverChalice,
}: TwoColumnsAccordionProps) {
  const { textColor: color } = useTextColorFromTheme()

  const accordionStyle = useStyle({
    borderColor: bordersTheme ?? color,
  })

  return (
    <div className={cx(css.TwoColumnsAccordion, className, accordionStyle)}>
      {items?.length > 0 && (
        <Accordion index={0} autoHide={false}>
          {items?.map(({ header, body }, key) => (
            <AccordionPanel
              className={cx(css.panel, accordionStyle)}
              key={`item_${key}`}
              index={key}
              head={(isActive: boolean) => (
                <div
                  className={cx(css.panelHead, headlineClassName, {
                    isActive,
                  })}>
                  <div className={cx(css.headline)}>{header}</div>
                  <div className={cx(css.icon)}>
                    {!isActive && <div>{`(+)`}</div>}
                    {isActive && <div>{`(–)`}</div>}
                  </div>
                </div>
              )}
              body={
                <div className={cx(css.panelBody)}>
                  {body?.map((row, index) => (
                    <RightColumnRow
                      key={`row_${key}_${index}`}
                      className={cx(css.row)}
                      {...row}
                    />
                  ))}
                </div>
              }
            />
          ))}
        </Accordion>
      )}
    </div>
  )
}

TwoColumnsAccordion.defaultProps = {}

export default TwoColumnsAccordion
